import API from '../dataApi';

export const initiatePersonTransfer = (data) =>
  API.post('/person-transfers', data);

export const getOutgoingPersonTransfers = (derasarId) =>
  API.get('/person-transfers/outgoing', { params: { derasarId } });

export const getIncomingPersonTransfers = (derasarId) =>
  API.get('/person-transfers/incoming', { params: { derasarId } });

export const respondToPersonTransfer = (id, action) =>
  API.put(`/person-transfers/${id}/respond`, { action });

export const cancelPersonTransfer = (id) =>
  API.put(`/person-transfers/${id}/cancel`);
